// extracted by mini-css-extract-plugin
export default {"select":"Dropdown_select__+TdOJ","option":"Dropdown_option__iLRpd"};